import React from 'react'
import PropTypes from 'prop-types'
import { Avatar } from 'antd'
import { StyledUser } from './styled'
const User = props => {
  const surname = props.user.surname && props.user.surname.substring(0, 1)
  return (
    <div>
      <Avatar size={'small'} icon="user" />
      <StyledUser>
        {props.user.name} {surname}. - {props.user.role}
      </StyledUser>
    </div>
  )
}
User.propTypes = {
  user: PropTypes.object
}
export default User
